// 数据处理

/**
 * 数组对象去重
 * @param {array} - arr 需要去重数组
 * @param {string} - type 去重依赖的属性
 */
export const duplicatesRemove = (arr, type) => {
  const arrMap = new Map();

  return arr.filter(item => !arrMap.has(item[type]) && arrMap.set(item[type], 1)) || [];
};


/**
 * 过滤对象value值为空
 * @param {object} - obj 需要过滤的对象
 */
export const filterUndefindObj = (obj) => {
  const dataType = [undefined, null];
  let newObj = {};

  Object.keys(obj)
    .filter(item => !dataType.some(_type => _type === obj[item]))
    .forEach(item => {
      newObj[item] = obj[item]
    })

  return newObj;
};
